import { Skeleton, Typography } from "@mui/material"
import { groupBy } from "@shared/lib/utils";
import MuiInput from "@shared/ui/mui-input/MuiInput";
import { StyledAddItem } from "./AddItem.styled";
import { UseFormReturn } from "react-hook-form";
import { ItemAdd } from "@models/item";
import { useTheme } from "@emotion/react";
import { useGetAccountStructureQuery } from "@features/structures/api/accountsStructure.api";


interface AddItemProps {
  useForm: UseFormReturn<ItemAdd>
}

function AddItem({ useForm }: AddItemProps) {

  const theme = useTheme();

  const { data: itemStructure, isFetching } = useGetAccountStructureQuery("פריט");

  const structureSortedByTitle = groupBy(itemStructure, "account_title")
  const customFieldsExist = structureSortedByTitle?.["מותאם אישית"]?.find(structure=> !!structure.show_form === true);


  return (
    <StyledAddItem>
      {isFetching && (<Skeleton variant="rectangular" height={500} animation="wave" sx={{ bgcolor: theme.colors.section_color }} />)}
      {!isFetching && itemStructure &&
        <>
          <div>
            <Typography variant="body1">פרטי פריט</Typography>
            <div className="fields">
              {structureSortedByTitle?.["פרטים"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

          <div>
            <Typography variant="body1">יצרן ודגם</Typography>
            <div className="fields">
              { structureSortedByTitle?.["יצרן ודגם"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

          <div>
            <Typography variant="body1">הכנסות והוצאות</Typography>
            <div className="fields">
              { structureSortedByTitle?.["הכנסות והוצאות"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

          <div>
            {customFieldsExist && (<Typography variant="body1">שדות מותאמים אישית:</Typography>)}
            <div className="fields">
              { structureSortedByTitle?.["מותאם אישית"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

        </>}

    </StyledAddItem>
  )
}

export default AddItem